import React, { useState, useEffect, useRef } from "react";
import { useAuth } from '../context/AuthContextProvider';
import { createPreference, updatePreference, deletePreference, listPreference } from "src/utilities/AppSyncPlusAPIs";
import { v4 as uuidv4 } from 'uuid';


import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  Box,
  Cards,
  Button,
  Header,
  Table,
  Badge,
  Autosuggest,
  ExpandableSection,
  SpaceBetween,
  Multiselect,
  ColumnLayout,
  Tabs,
  Pagination,
  Spinner,
  ButtonDropdown,
  CopyToClipboard,
  ContentLayout,
  Icon,
  PieChart,
  Select,
  HelpPanel,
  Grid,
  Steps,
  Popover,
  SegmentedControl,
  TextContent,
  Toggle,
  Link,
  Modal,
  FormField,
  Input,
  StatusIndicator
} from "@amzn/awsui-components-react";

import "./homepage.scss";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";


import CPBoardView from "./ClosePortal/components/CPBoardView"
import CustomMultipleResourcePage from "./ClosePortal/components/CustomMultipleResourcePage"
import CustomSingleResourcePage from "./ClosePortal/components/CustomSingleResourcePage"
import { getBrassIsLDAPOwnerOf, getOwnersByUser, getOwnersForAdminUser, getOwnerCustomTabs, hideOrUnhideCPTab, getOwnerTabPreferences, createCustomTabOfOwner, updateCustomTabOfOwner, deleteCustomTabOfOwner, createClosePortalOwner, updateClosePortalOwner, getOwnerDetails } from "src/utilities/CloseAPIs"
import { TEMPLATE_APP } from 'src/Ateam-BI/Templates/Constants';

import { checkIfSupportAdmin, checkIfPortalAdmin } from 'src/checkPageAccess';
import { configureGenericAppSync, configurePlusAppsync } from 'src/context/AuthContextUtility';
import { isMemberOf } from "src/checkPageAccess";

import { closePortalDefaultTabs } from "./ClosePortal/constants"
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { useDirectReports } from "src/hooks/useSuggestedLogins";
import { getServiceForMetricsByPath, captureMetrics, createKatalTimerStopWatch, publishTimerStopwatchMetric } from "src/katalMetrics/metricsHelperMethods"
import { getLocalCache, setLocalCache } from "src/utilities/CacheHelper"
import { GET_OWNERS_CACHE_KEY, cacheVariables } from "src/AppConstants/CacheConstants"
import { saveTabOrder, getTabOrder, applyTabOrder, applyTabOrderWithFixedTabs, getVisibleTabNames, getReorderableTabs, cleanupTabOrder, FIXED_TABS } from "src/utilities/TabOrderUtils"




import Apps from "./Apps"
import CreateTeamModal from "./CreateTeamModal"
import CustomizeTabsModal from "./CustomizeTabsModal"
import { getClosePortalBanners } from "src/Ateam-BI/Banners/BannerUtils";
import BannerContainer from "src/Ateam-BI/Banners/BannerContainer";
import { BannerDisplayLocation } from "src/Ateam-BI/Banners/BannerTypes";


const AllProducts = (props) => {
  const history = useHistory();
  const isCurrentAppAuthorised = useSelector(
    (globalState) => globalState.auth.isCurrentAppAuthorized
  );

  const { tabIdFromURL } = useParams()
  const { id } = useParams()

  const userAuthenticationDetails = useAuth();
  const firstName = userAuthenticationDetails.GivenName;
  const currentUser = useSelector((globalState) => globalState.auth.userId)
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const ln = useLocation()
  const search = useLocation().search
  const [activeTabId, setActiveTabId] = useState();
  const [activeHref, setActiveHref] = useState()
  const [visible, setVisible] = useState(false)
  const [customizeTabsVisible, setCustomizeTabsVisible] = useState(false)

  const isPortalAdmin = useSelector((globalState) => globalState.auth.isPortalAdmin)
  const isSupportAdmin = useSelector((globalState) => globalState.auth.isSupportAdmin)
  const [showLoadingIcon, setShowLoadingIcon] = useState(true)
  const [selectedCPView, setSelectedCPView] = useState()
  const [cpOwnerOptions, setCpOwnerOptions] = useState([])
  const [viewAccess, setViewAccess] = useState()
  const [addOrEditAccess, setAddOrEditAccess] = useState()
  const searchParams = new URLSearchParams(search)
  const currentHour = (new Date()).getHours()
  const [errorText, setErrorText] = useState()
  const [selectedSegmentId, setSelectedSegmentId] = useState("tab-controls")
  const [selectedTabControlsSegmentId, setSelectedTabControlsSegmentId] = useState("add")
  const [selectedUpdateOrDeleteTab, setSelectedUpdateOrDeleteTab] = useState()
  const [selectedTabToUnhide, setSelectedTabToUnhide] = useState()
  const [updateTabNameInput, setUpdateTabNameInput] = useState('')
  const [newTabName, setNewTabName] = useState('')
  const [banners, setBanners] = useState([]);
  const [greeting, setGreeting] = useState(() => {
    if (currentHour < 12) {
      return "Good Morning"
    } else if (currentHour < 18) {
      return "Good Afternoon"
    } else {
      return "Good Evening"
    }
  })
  const [inIframe, setInIframe] = useState(window.self !== window.top)
  const [tabs, setTabs] = useState([])
  const [allTabs, setAllTabs] = useState([])
  const [allCustomTabs, setAllCustomTabs] = useState([])
  const [hiddenTabs, setHiddenTabs] = useState([])
  const [modalLoading, setModalLoading] = useState(false)
  const [fieldMetadata, setFieldMetadata] = useState({});
  const [regions, setRegions] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([])
  const [selectedOrgs, setSelectedOrgs] = useState([])
  const [selectedVP, setSelectedVP] = useState()
  const [newTeamName, setNewTeamName] = useState('')
  const [newTeamLDAP, setNewTeamLDAP] = useState('')
  const { directReports, directReportsLoading, getDirectReportsCaller } = useDirectReports();
  const [customTabsLoaded, setCustomTabsLoaded] = useState(false)

  const [selectedTeamToEdit, setSelectedTeamToEdit] = useState(null)
  const [isAteamBI, setIsAteamBI] = useState(null)
  const [selectedTabType, setSelectedTabType] = useState()
  const [ownerTabConfigInfo, setOwnerTabConfigInfo] = useState([])
  const [currentTabPreferences, setCurrentTabPreferences] = useState([])
  const [tabConfigInfoLoaded, setTabConfigInfoLoaded] = useState(false)

  const getCachedOwners = () => getLocalCache(GET_OWNERS_CACHE_KEY, cacheVariables[GET_OWNERS_CACHE_KEY]?.expiry);
  const setCachedOwners = (data) => setLocalCache(GET_OWNERS_CACHE_KEY, data);

  useEffect(() => {
    setInIframe(window.self !== window.top)
  }, [])

  useEffect(() => {
    if (ln.pathname?.toLowerCase()?.startsWith('/appslibrary')) {
      setActiveTabId('AppsLibrary')
    } else {
      let tabId = tabIdFromURL ? tabIdFromURL?.replaceAll('%2F', '/') : 'HOME';
      setActiveTabId(tabId)
    }
  }, [ln, tabIdFromURL])


  // New
  useEffect(() => {
    if (selectedCPView) {
      updateAccess()
      setTabConfigInfoLoaded(false)
      setTabOrderLoaded(false)
      setCustomTabsLoaded(false)
      setTabs([])
      setAllTabs([])
      setAllCustomTabs([])
      setHiddenTabs([])
      setOwnerTabConfigInfo([])
      setTabConfigFromPreferences()


      if (activeTabId && activeTabId?.toLowerCase() !== 'appslibrary' && selectedCPView?.value) {
        if (searchParams.toString() && activeTabId?.toLowerCase() !== 'home') {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}?${searchParams.toString()}`)
        } else {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}`)
        }
      }
    }
  }, [selectedCPView])

  // useEffect(() => {
  //   if (ownerTabConfigInfo?.length > 0) {

  //     const visibleTabs = ownerTabConfigInfo?.filter((tab) => tab?.visible)
  //     setTabs(visibleTabs)
  //     setAllTabs(ownerTabConfigInfo)
  //     const customTabs = ownerTabConfigInfo?.filter((tab) => tab?.isDefault === false)
  //     setAllCustomTabs(customTabs)
  //     const hiddenTabs = ownerTabConfigInfo?.filter((tab) => tab?.visible === false)
  //     setHiddenTabs(hiddenTabs)
  //   } else {
  //     setTabs(closePortalDefaultTabs)
  //     setAllTabs(closePortalDefaultTabs)
  //     setAllCustomTabs([])
  //     setHiddenTabs([])
  //   }

  // }, [ownerTabConfigInfo])

  useEffect(() => {
    if (selectedCPView && allTabs?.length >= 1 && tabConfigInfoLoaded === true) {
      setTabOrderLoaded(true)
      setCustomTabsLoaded(true)
    } else {
      setTabOrderLoaded(false)
      setCustomTabsLoaded(false)
    }

  }, [selectedCPView, tabConfigInfoLoaded])




  useEffect(() => {
    if (customTabsLoaded === true) {
      
      if (!tabs?.map((tab)=>(tab?.id)).includes(tabIdFromURL?.replaceAll('%2F', '/')) && activeTabId?.toLowerCase() !== 'appslibrary') {
        setActiveTabId('HOME')
        history.push(`/ClosePortal/HOME/Page/${selectedCPView?.value}`)
      }
    }
  }, [customTabsLoaded, hiddenTabs])




  useEffect(() => {
    if (visible === true) {
      loadSearchDropDownValues()
    }
  }, [visible])

  useEffect(() => {
    setUpdateTabNameInput('')
    setNewTabName('')
    setSelectedTabToUnhide()
    setSelectedUpdateOrDeleteTab()
    setSelectedOrgs([])
    setSelectedRegions([])
    setNewTeamName('')
    setNewTeamLDAP('')
    setSelectedVP()
    if (selectedSegmentId === 'create-team') {
      loadSearchDropDownValues()
    }
  }, [selectedSegmentId, selectedTabControlsSegmentId])

  useEffect(() => {
    // loadData()
    checkAteamBIMembership()
  }, [])

  useEffect(() => {
    if (isAteamBI != null) {
      loadData()
    }

  }, [isAteamBI])


  useEffect(() => {
    const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
    setOrganizations(orgs);

    const regions = fieldMetadata[TEMPLATE_APP.REGION]?.values
    setRegions(regions)

  }, [fieldMetadata])


  const loadSearchDropDownValues = async () => {
    setModalLoading(true)
    let res = await getEditableFields()
    setFieldMetadata(res)
    setModalLoading(false)
  }


  const setTabConfigFromPreferences = async () => {
    listPreference(
      selectedCPView.value,
      'CLOSE_PORTAL',
      'CLOSE_PORTAL_TABS_CONFIG',
      function onSuccessResponse(response) {
        const preferences = response?.data?.listPreference?.items || [];

        const validPreferences = preferences.filter(pref => {
          if (pref.information) {
            const information = typeof pref.information === 'string'
              ? JSON.parse(pref.information)
              : pref.information;
            return information;
          }
          return false;
        });

        setCurrentTabPreferences(validPreferences)

        if (validPreferences?.length > 0) {
          const info = JSON.parse(validPreferences[0]?.information)
          if (info?.tabConfiguration?.closePortalTabs) {
            const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
            setOwnerTabConfigInfo(tabConfigInfo)
            const visibleTabs = tabConfigInfo?.filter((tab) => tab?.visible)
            setTabs(visibleTabs)
            setAllTabs(tabConfigInfo)
            const customTabs = tabConfigInfo?.filter((tab) => tab?.isDefault === false)
            setAllCustomTabs(customTabs)
            const hiddenTabs = tabConfigInfo?.filter((tab) => tab?.visible === false)
            setHiddenTabs(hiddenTabs)
            setTabConfigInfoLoaded(true)
          }
        } else {
          setOwnerTabConfigInfo([])
          setTabs(closePortalDefaultTabs)
          setAllTabs(closePortalDefaultTabs)
          setAllCustomTabs([])
          setHiddenTabs([])
          setTabConfigInfoLoaded(true)
        }
      },
      function onFailureResponse(error) {
        configureGenericAppSync()
      }
    );

  }
  const handleOwnerSelection = (ownerSelectOptions) => {
    if (ownerSelectOptions.length > 0) {
      if (id) {
        const index = ownerSelectOptions?.findIndex((element) => {
          return element?.value == id
        })
        if (index === -1) {
          setSelectedCPView(ownerSelectOptions[0])
          setActiveTabId("HOME")
          history.push(`/ClosePortal/HOME/Page/${ownerSelectOptions[0]}`)
        } else {
          setSelectedCPView(ownerSelectOptions[index])
        }
      } else {
        setSelectedCPView(ownerSelectOptions[0])
      }
    }
  }

  const loadData = async () => {
    if (isPortalAdmin || isSupportAdmin) {
      const r = await getOwnersForAdminUser(function onSuccess(result) {
        const data = result.data.getOwnersForAdminUserRDS
        const owners = JSON.parse(data)
        const ownerSelectOptions = owners.map((owner) => {
          return { label: owner?.owner_name, value: String(owner?.owner_id), owner_identifier: owner?.owner_identifier, owner_type: owner?.owner_type }
        })
        setCpOwnerOptions(ownerSelectOptions)
        handleOwnerSelection(ownerSelectOptions)
        configureGenericAppSync()
        setShowLoadingIcon(false)
      }, function onFailure(response) {
        configureGenericAppSync()
        setShowLoadingIcon(false)
      })
    } else {
      if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
        const cachedData = getCachedOwners();
        if (cachedData) {
          setCpOwnerOptions(cachedData)
          handleOwnerSelection(cachedData)
          configureGenericAppSync()
          setShowLoadingIcon(false)
          return;
        }
      }

      const r = await getOwnersByUser(currentStage, function onSuccess(result) {
        const data = result.data.getOwnersByUser
        const owners = JSON.parse(data)
        const ownerSelectOptions = owners.map((owner) => {
          return { label: owner?.owner_name, value: owner?.owner_id, owner_identifier: owner?.owner_identifier, owner_type: owner?.owner_type }
        })
        if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
          setCachedOwners(ownerSelectOptions)
        }
        setCpOwnerOptions(ownerSelectOptions)
        handleOwnerSelection(ownerSelectOptions)
        configureGenericAppSync()
        setShowLoadingIcon(false)
      }, function onFailure(response) {
        configureGenericAppSync()
        setShowLoadingIcon(false)
      })
    }
  }

  const updateAccess = async () => {

    if (selectedCPView && selectedCPView?.owner_type === 'DEFAULT') {
      setViewAccess(true)
      if (isSupportAdmin || isPortalAdmin) {
        setAddOrEditAccess(true)
      } else {
        setAddOrEditAccess(false)
      }
    } else if (selectedCPView && selectedCPView?.owner_type === 'TEAM') {
      const isLDAPMemberOf = await isMemberOf(currentUser, selectedCPView?.owner_identifier, currentStage)
      let isLDAPOwnerOf;
      await configurePlusAppsync()
      const res = await getBrassIsLDAPOwnerOf(selectedCPView?.owner_identifier, currentStage, function onSuccess(result) {
        isLDAPOwnerOf = result.data.getBrassIsLDAPOwnerOf
        if (isLDAPOwnerOf || isLDAPMemberOf || isSupportAdmin || isPortalAdmin) {
          setViewAccess(true)
        } else {
          setViewAccess(false)
        }

        if (isLDAPOwnerOf || isSupportAdmin || isPortalAdmin) {
          setAddOrEditAccess(true)
        } else {
          setAddOrEditAccess(false)
        }
        configureGenericAppSync()
      }, function onFailure(response) {
        configureGenericAppSync()
      })
    } else if (selectedCPView && selectedCPView?.owner_type === 'USER' && selectedCPView?.owner_identifier === currentUser) {
      setViewAccess(true)
      setAddOrEditAccess(true)
    } else {
      setViewAccess(false)
      setAddOrEditAccess(false)
    }
  }

  const updateTab = (tabId, href) => {
    if (tabs?.map((tab) => (tab?.id)).includes(tabId)) {
      setActiveHref(href)
      setActiveTabId(tabId)
      return true;
    } else {
      return false;
    }

  }

  const addOrUpdateTabConfig = async (tabConfig) => {

    if (selectedCPView) {

      const newPreferenceId = uuidv4();
      const information = { "closePortalOwner": selectedCPView?.value, "tabConfiguration": { "closePortalTabs": tabConfig } }
      const label = `Tab configuration for Close Portal Page ${selectedCPView?.label}`
      if (ownerTabConfigInfo?.length <= 0) {
        createPreference(
          newPreferenceId,
          'CLOSE_PORTAL_TABS_CONFIG',
          label,
          selectedCPView?.value,
          'CLOSE_PORTAL',
          currentUser,
          information,
          null,
          (response) => {
            const newPreference = {
              preferenceId: newPreferenceId,
              label: label,
              associationId: selectedCPView?.value,
              associationIdType: 'CLOSE_PORTAL',
              preferenceType: 'CLOSE_PORTAL_TABS_CONFIG',
              createdBy: currentUser,
              lastUpdatedBy: currentUser,
              lastUpdatedTimestamp: Date.now().toString(),
              information: information
            };
            setCurrentTabPreferences([newPreference]);
            const info = newPreference?.information
            if (info?.tabConfiguration?.closePortalTabs) {
              const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
              setOwnerTabConfigInfo(tabConfigInfo)
              const visibleTabs = tabConfigInfo?.filter((tab) => tab?.visible)
              setTabs(visibleTabs)
              setAllTabs(tabConfigInfo)
              const customTabs = tabConfigInfo?.filter((tab) => tab?.isDefault === false)
              setAllCustomTabs(customTabs)
              const hiddenTabs = tabConfigInfo?.filter((tab) => tab?.visible === false)
              setHiddenTabs(hiddenTabs)

            }
          },
          (error) => {
            console.error('Error creating preferences:', error);
            const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
          }
        );
      } else {
        const currentPreferenceId = currentTabPreferences[0]?.preferenceId
        updatePreference(
          currentPreferenceId,
          label,
          currentUser,
          information,
          (response) => {
            const newPreference = {
              preferenceId: currentPreferenceId,
              label: label,
              associationId: props?.closePortalowner?.value,
              associationIdType: 'CLOSE_PORTAL',
              preferenceType: 'CLOSE_PORTAL_TABS_CONFIG',
              createdBy: currentUser,
              lastUpdatedBy: currentUser,
              lastUpdatedTimestamp: Date.now().toString(),
              information: information
            };
            setCurrentTabPreferences([newPreference]);
            const info = newPreference?.information
            if (info?.tabConfiguration?.closePortalTabs) {
              const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
              setOwnerTabConfigInfo(tabConfigInfo)
              const visibleTabs = tabConfigInfo?.filter((tab) => tab?.visible)
              setTabs(visibleTabs)
              setAllTabs(tabConfigInfo)
              const customTabs = tabConfigInfo?.filter((tab) => tab?.isDefault === false)
              setAllCustomTabs(customTabs)
              const hiddenTabs = tabConfigInfo?.filter((tab) => tab?.visible === false)
              setHiddenTabs(hiddenTabs)
            }
          },
          (error) => {
            console.error('Error updating preferences:', error);
            const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
          }
        )
      }

    }
  }



  const hideOrUnhideCustomTab = async (tab, hide) => {

    const tabConfig = allTabs?.map((currentTab) => {
      if (tab === currentTab?.id) {
        return {
          ...currentTab,
          "visible": !hide,
        }
      } else {
        return currentTab
      }
    })
    addOrUpdateTabConfig(tabConfig)
    resetModalParams()

  }

  const addNewCustomTab = async () => {
    if (newTabName?.trim() !== '' && selectedTabType) {
      if (allCustomTabs?.length >= 10) {
        setErrorText('Cannot create more than 10 custom tabs!')
        return;
      } else if (allTabs?.includes(newTabName?.trim())) {
        setErrorText('A tab with same name exists!')
        return;
      } else {
        setModalLoading(true)
        await createCustomTabOfOwner(newTabName?.trim(), selectedCPView?.value, currentUser, selectedTabType?.value, function onSuccess(result) {
          
          const tabConfig = allTabs?.concat({
            "id": newTabName?.trim(),
            "label": newTabName?.trim(),
            "isDefault": false,
            "order": closePortalDefaultTabs?.length + 1,
            "tabType": selectedTabType?.value,
            "visible": true
          })
          addOrUpdateTabConfig(tabConfig)
          resetModalParams()
          configureGenericAppSync()
        }, function onFailure(response) {
          configureGenericAppSync()
        })
      }
    } else {
      setErrorText('All fields are required!')
      return;
    }
  }

  const updateExistingCustomTab = async () => {
    if (selectedUpdateOrDeleteTab) {
      if (updateTabNameInput?.trim() === '') {
        setErrorText('Please provide a new tab name to update!')
        return;
      } else if (allTabs?.includes(updateTabNameInput?.trim())) {
        setErrorText('A tab with same name exists!')
        return;
      } else {
        setModalLoading(true)
        await updateCustomTabOfOwner(selectedCPView?.value, selectedUpdateOrDeleteTab?.value, updateTabNameInput?.trim(), function onSuccess(result) {
          
          const tabConfig = allTabs?.map((tab) => {
            if (selectedUpdateOrDeleteTab?.value === tab?.id) {
              return {
                ...tab,
                "id": updateTabNameInput?.trim(),
                "label": updateTabNameInput?.trim(),
              }
            } else {
              return tab
            }
          })

          addOrUpdateTabConfig(tabConfig)
          resetModalParams()
          configureGenericAppSync()
        }, function onFailure(response) {
          configureGenericAppSync()
        })
      }
    } else {
      setErrorText('Please select a tab to update!')
      return;
    }
  }

  const deleteExistingCustomTab = async () => {
    if (selectedUpdateOrDeleteTab) {
      setModalLoading(true)
      await deleteCustomTabOfOwner(selectedCPView?.value, selectedUpdateOrDeleteTab?.value, function onSuccess(result) {

        const tabConfig = allTabs?.filter((tab) => (selectedUpdateOrDeleteTab?.value !== tab?.id))

        addOrUpdateTabConfig(tabConfig)
        resetModalParams()
        setActiveTabId("HOME")
        configureGenericAppSync()
      }, function onFailure(response) {
        configureGenericAppSync()
      })

    } else {
      setErrorText('Please select a tab to delete!')
      return;
    }
  }

  const resetModalParams = () => {
    setVisible(false)
    setCustomizeTabsVisible(false)
    setModalLoading(false)
    setErrorText()
    setSelectedSegmentId("tab-controls")
    setSelectedTabControlsSegmentId("add")
    setNewTabName('')
    setSelectedUpdateOrDeleteTab()
    setUpdateTabNameInput('')
    setSelectedTabToUnhide()
    setSelectedOrgs([])
    setSelectedRegions([])
    setNewTeamName('')
    setNewTeamLDAP('')
    setSelectedVP()
    setSelectedTeamToEdit(null)
  }

  const createNewOwner = async (ownerType = 'TEAM') => {
    const missingFields = [];

    if (!newTeamName?.trim()) {
      missingFields.push('Team Display name');
    }
    if (!newTeamLDAP?.trim()) {
      missingFields.push('LDAP');
    }
    if (!selectedOrgs || selectedOrgs.length === 0) {
      missingFields.push('Organization');
    }
    if (!selectedRegions || selectedRegions.length === 0) {
      missingFields.push('Region');
    }
    if (!selectedVP) {
      missingFields.push('VP');
    }

    if (missingFields.length > 0) {
      setErrorText(`Please fill in all required fields: ${missingFields.join(', ')}`);
      return;
    }

    setModalLoading(true)
    let regions = []
    let orgs = []
    let vps = []

    if (selectedOrgs?.length >= 1) {
      orgs = selectedOrgs?.map((org) => (org?.value))
    }
    if (selectedRegions?.length >= 1) {
      regions = selectedRegions?.map((region) => (region?.value))
    }
    if (selectedVP) {
      vps = [selectedVP?.value]
    }

    await createClosePortalOwner(newTeamName?.trim(), newTeamLDAP?.trim(), ownerType, currentUser, orgs, regions, vps, function onSuccess(result) {
      localStorage.removeItem(GET_OWNERS_CACHE_KEY);
      loadData()
      resetModalParams()
      configureGenericAppSync()
    }, function onFailure(response) {
      setErrorText(response)
      setModalLoading(false)
      configureGenericAppSync()
    })
  }

  const sanitizeResponseData = (data) => {
    if (!data || typeof data !== 'string') {
      return data;
    }

    try {

      let sanitized = data;

      sanitized = sanitized.replace(/(\w+)=/g, '"$1":');

      sanitized = sanitized.replace(/:\s*\[([^\]]*)\]/g, (match, arrayContent) => {
        if (!arrayContent.trim()) {
          return ': []';
        }

        const elements = [];
        let currentElement = '';
        let inQuotes = false;

        for (let i = 0; i < arrayContent.length; i++) {
          const char = arrayContent[i];

          if (char === '"' && (i === 0 || arrayContent[i - 1] !== '\\')) {
            inQuotes = !inQuotes;
            currentElement += char;
          } else if (char === ',' && !inQuotes) {
            if (currentElement.trim()) {
              elements.push(currentElement.trim());
            }
            currentElement = '';
          } else {
            currentElement += char;
          }
        }

        if (currentElement.trim()) {
          elements.push(currentElement.trim());
        }

        const processedElements = elements.map(element => {
          const trimmed = element.trim();

          if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
            return trimmed;
          }

          if (/^[\d.]+$/.test(trimmed)) {
            return trimmed;
          }

          if (/^(true|false|null)$/i.test(trimmed)) {
            return trimmed.toLowerCase();
          }

          return `"${trimmed}"`;
        });

        return `: [${processedElements.join(', ')}]`;
      });

      sanitized = sanitized.replace(/:\s*([^,\[\]{}"\d\s][^,\[\]{}]*?)(?=[,\]}])/g, (match, value) => {
        const trimmedValue = value.trim();

        if (trimmedValue.startsWith('"') ||
          /^[\d.]+$/.test(trimmedValue) ||
          /^(true|false|null)$/i.test(trimmedValue) ||
          trimmedValue.startsWith('[') ||
          trimmedValue.startsWith('{')) {
          return `: ${trimmedValue}`;
        }

        return `: "${trimmedValue}"`;
      });

      sanitized = sanitized.replace(/:\s*([^,\[\]{}"][^,\[\]{}]*[^,\[\]{}"])(?=[,\]}])/g, (match, value) => {
        const trimmedValue = value.trim();

        if (!trimmedValue.startsWith('"') &&
          !trimmedValue.endsWith('"') &&
          !/^[\d.]+$/.test(trimmedValue) &&
          !/^(true|false|null)$/i.test(trimmedValue)) {
          return `: "${trimmedValue}"`;
        }

        return `: ${trimmedValue}`;
      });


      return JSON.parse(sanitized);
    } catch (error) {
      console.error('Failed to sanitize data:', error);
      console.error('Original data:', data);
      console.error('Attempted sanitization:', sanitized);

      try {
        let fallbackSanitized = data
          .replace(/(\w+)=/g, '"$1":')
          .replace(/:\s*([^,\[\]{}]+?)(?=[,\]}])/g, (match, value) => {
            const trimmed = value.trim();
            if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
              const arrayContent = trimmed.slice(1, -1);
              if (!arrayContent.trim()) return ': []';

              const elements = arrayContent.split(',').map(el => {
                const element = el.trim();
                if (/^[\d.]+$/.test(element) || /^(true|false|null)$/i.test(element)) {
                  return element;
                }
                return `"${element}"`;
              });

              return `: [${elements.join(', ')}]`;
            }

            if (/^[\d.]+$/.test(trimmed) || /^(true|false|null)$/i.test(trimmed)) {
              return `: ${trimmed}`;
            }

            return `: "${trimmed}"`;
          });

        return JSON.parse(fallbackSanitized);
      } catch (fallbackError) {
        console.error('Fallback sanitization also failed:', fallbackError);
        throw new Error('Invalid data format received from server - unable to parse');
      }
    }
  };

  const checkAteamBIMembership = () => {
    setIsAteamBI(isPortalAdmin || isSupportAdmin);
  }

  const loadTeamDetails = async (teamId, retryCount = 0) => {
    setModalLoading(true);

    setErrorText('');

    await getOwnerDetails(teamId, function onSuccess(result) {
      try {
        const data = result.data.getOwnerDetailsRDS;

        if (!data) {
          console.error('No data returned from getOwnerDetailsRDS');
          setErrorText('No team data found');
          configureGenericAppSync();
          setModalLoading(false);
          return;
        }

        let teamDetails;

        if (typeof data === 'string') {
          if (data.trim() === '' || data.trim() === 'null' || data.trim() === 'undefined') {
            console.error('Empty or invalid data string:', data);
            setErrorText('Invalid team data format');
            configureGenericAppSync();
            setModalLoading(false);
            return;
          }

          try {
            teamDetails = JSON.parse(data);
          } catch (parseError) {
            try {
              teamDetails = sanitizeResponseData(data);
            } catch (sanitizeError) {
              console.error('JSON parse error for data:', data);
              console.error('Parse error details:', parseError);
              console.error('Sanitization error:', sanitizeError);
              setErrorText('Failed to parse team data - invalid format received from server');
              configureGenericAppSync();
              setModalLoading(false);
              return;
            }
          }
        } else if (Array.isArray(data)) {
          teamDetails = data;
        } else if (data && typeof data === 'object') {
          teamDetails = [data];
        } else {
          console.error('Unexpected data format:', data);
          setErrorText('Unexpected team data format');
          configureGenericAppSync();
          setModalLoading(false);
          return;
        }


        if (teamDetails && Array.isArray(teamDetails) && teamDetails.length > 0) {
          const team = teamDetails[0];

          setNewTeamName(team.owner_name || '');
          setNewTeamLDAP(team.owner_identifier || '');

          if (team.organizations !== undefined && team.organizations !== null) {
            try {
              let orgData = team.organizations;

              if (typeof orgData === 'string' && orgData.trim() !== '') {
                orgData = JSON.parse(orgData);
              }

              if (Array.isArray(orgData)) {
                const teamOrgs = orgData.map(org =>
                  organizations?.find(o => o.value === org) || { label: org, value: org }
                ).filter(Boolean);
                setSelectedOrgs(teamOrgs);
              } else {
                setSelectedOrgs([]);
              }
            } catch (e) {
              console.error('Error parsing organizations:', e);
              setSelectedOrgs([]);
            }
          } else {
            setSelectedOrgs([]);
          }

          if (team.regions !== undefined && team.regions !== null) {
            try {
              let regionData = team.regions;

              if (typeof regionData === 'string' && regionData.trim() !== '') {
                regionData = JSON.parse(regionData);
              }

              if (Array.isArray(regionData)) {
                const teamRegions = regionData.map(region =>
                  regions?.find(r => r.value === region) || { label: region, value: region }
                ).filter(Boolean);
                setSelectedRegions(teamRegions);
              } else {
                setSelectedRegions([]);
              }
            } catch (e) {
              console.error('Error parsing regions:', e);
              setSelectedRegions([]);
            }
          } else {
            setSelectedRegions([]);
          }

          if (team.vps !== undefined && team.vps !== null) {
            try {
              let vpData = team.vps;

              if (typeof vpData === 'string' && vpData.trim() !== '') {
                vpData = JSON.parse(vpData);
              }

              if (Array.isArray(vpData) && vpData.length > 0) {
                const vp = directReports?.find(dr => dr.value === vpData[0]) ||
                  { label: vpData[0], value: vpData[0] };
                setSelectedVP(vp);
              } else {
                setSelectedVP(null);
              }
            } catch (e) {
              console.error('Error parsing VPs:', e);
              setSelectedVP(null);
            }
          } else {
            setSelectedVP(null);
          }
        } else {
          console.error('No valid team details found');
          setErrorText('No team details found');
        }

        configureGenericAppSync();
        setModalLoading(false);
      } catch (error) {
        console.error('Error in loadTeamDetails:', error);
        setErrorText('Failed to load team details: ' + error.message);
        configureGenericAppSync();
        setModalLoading(false);
      }
    }, function onFailure(response) {
      console.error('getOwnerDetails failed:', response);

      if (response && (
        response.message?.includes('ERR_SOCKET_NOT_CONNECTED') ||
        response.message?.includes('Network Error') ||
        response.message?.includes('ERR_NETWORK') ||
        response.networkError
      ) && retryCount < 2) {
        setErrorText(`Network error, retrying... (${retryCount + 1}/3)`);

        setTimeout(() => {
          loadTeamDetails(teamId, retryCount + 1);
        }, 1000 * (retryCount + 1));
        return;
      }

      if (retryCount >= 2) {
        setErrorText('Failed to load team details after multiple attempts. Please check your network connection and try again.');
      } else {
        setErrorText('Failed to load team details. Please try again.');
      }

      configureGenericAppSync();
      setModalLoading(false);
    });
  }

  const updateTeam = async () => {
    const missingFields = [];

    if (!selectedTeamToEdit) {
      missingFields.push('Team selection');
    }
    if (!newTeamName?.trim()) {
      missingFields.push('Team Display name');
    }
    if (!newTeamLDAP?.trim()) {
      missingFields.push('LDAP');
    }
    if (!selectedOrgs || selectedOrgs.length === 0) {
      missingFields.push('Organization');
    }
    if (!selectedRegions || selectedRegions.length === 0) {
      missingFields.push('Region');
    }
    if (!selectedVP) {
      missingFields.push('VP');
    }

    if (missingFields.length > 0) {
      setErrorText(`Please fill in all required fields: ${missingFields.join(', ')}`);
      return;
    }

    setModalLoading(true);

    let regions = [];
    let orgs = [];
    let vps = [];

    if (selectedOrgs?.length >= 1) {
      orgs = selectedOrgs?.map((org) => (org?.value));
    }
    if (selectedRegions?.length >= 1) {
      regions = selectedRegions?.map((region) => (region?.value));
    }
    if (selectedVP) {
      vps = [selectedVP?.value];
    }

    await updateClosePortalOwner(
      selectedTeamToEdit.value,
      newTeamName?.trim(),
      newTeamLDAP?.trim(),
      orgs,
      regions,
      vps,
      currentUser,
      function onSuccess(result) {
        localStorage.removeItem(GET_OWNERS_CACHE_KEY);
        loadData();
        resetModalParams();
        configureGenericAppSync();
      },
      function onFailure(response) {
        setErrorText(response || 'Failed to update team');
        setModalLoading(false);
        configureGenericAppSync();
      }
    );
  }

  const resetHref = () => {
    setActiveHref()
  }

  const handleReorderTabs = async (newOrder) => {
    if (selectedCPView?.value) {
      try {
        setModalLoading(true);

        const fixedTabs = [{
          "id": "HOME",
          "label": "Home",
          "isDefault": true,
          "order": 1,
          "tabType": "BOARD",
          "visible": true
        },
        {
          "id": "AppsLibrary",
          "label": "Apps Library",
          "isDefault": true,
          "order": 2,
          "tabType": "APPS",
          "visible": true
        }]
        const tabConfig = fixedTabs?.concat(newOrder)

        await addOrUpdateTabConfig(tabConfig)

        // await saveTabOrder(selectedCPView.value, newOrder);

        // await loadOrderedTabs(true);

        setCustomizeTabsVisible(false);
        setModalLoading(false);
        setErrorText();
        setSelectedTabControlsSegmentId("add");

      } catch (error) {
        console.error('Failed to save tab order:', error);
        setErrorText('Failed to save tab order. Please try again.');
        setModalLoading(false);
      }
    }
  };


  const [orderedTabs, setOrderedTabs] = useState({
    fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
    orderedReorderableTabs: [
      ...allTabs.filter(tab => !FIXED_TABS.includes(tab.id))
    ]
  });
  const [tabOrderLoaded, setTabOrderLoaded] = useState(false);

  useEffect(() => {
    setOrderedTabs({
      fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
      orderedReorderableTabs: [
        ...allTabs?.filter(tab => !FIXED_TABS.includes(tab.id))
      ]
    })
  }, [allTabs])


  const Content = (
    showLoadingIcon ?
      <Box>
        <Spinner size="large" />
      </Box>
      :

      <Box>
        <br></br>
        <ContentLayout
        >

          <Header
            actions={

              <Button
                ariaLabel="Open our t.corp template (opens in new tab)"
                href="https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5"
                iconAlign="right"
                iconName="external"
                target="_blank"
              >
                Contact us
              </Button>
            }
          >

            <Box display={inIframe ? "none" : "block"}>
              <SpaceBetween direction="vertical" size="m">
                <Box
                  variant="h3"
                  padding={{ bottom: "s" }}
                  fontSize="heading-l"
                  color="inherit">{greeting}, {firstName} ! <>
                      <Box variant="h3"
                        padding="n"
                        fontSize="heading-l" display="inline">You are viewing the </Box>
                      {selectedCPView && cpOwnerOptions && cpOwnerOptions.length > 0 && (
                        <Box display="inline-block" margin={{ left: 'xs', right: 'xs' }}>
                          <Select
                            className="owner-select-dropdown"
                            selectedOption={selectedCPView}
                            onChange={({ detail }) => {
                              setSelectedCPView(detail.selectedOption)
                            }}
                            options={cpOwnerOptions}
                            disabled={false}
                            filteringType="auto"
                          />
                        </Box>
                      )}
                      <Box variant="h3"
                        padding="n"
                        fontSize="heading-l" display="inline"> page </Box>
                      {addOrEditAccess && (
                        <Box display="inline-block" margin={{ left: 'xs' }}>
                          <Button
                            variant="icon"
                            iconName="settings"
                            onClick={() => { setVisible(true) }}
                            ariaLabel="Page settings"
                          />
                        </Box>
                      )}
                    </></Box>
                {/* {selectedCPView?.label && (
                  <Box padding={{ bottom: "s" }}>
                    <Box variant="h3"

                      fontSize="heading-l"
                      display="inline">Welcome to </Box>
                    <Link
                      href={`https://${currentStage === 'prod' ? '' : 'beta.'}bi-central.accounting.amazon.dev`}
                      variant="secondary"
                      external={inIframe}
                      fontSize="heading-l"

                    >
                      <strong>  ATEAM's Close Portal </strong>
                    </Link>
                    
 
                  </Box>
                )} */}
              </SpaceBetween>
            </Box>
            {/* </SpaceBetween> */}
          </Header>
          <Container>
            <BannerContainer displayLocations={[BannerDisplayLocation.ClosePortal]} roundedCorners={true} parameters={{ closePortalOwnerId: selectedCPView?.value }} />

            {addOrEditAccess && activeTabId !== 'AppsLibrary' && (
              <Box float="right" margin={{ top: 's', bottom: 's' }}>
                <Link
                  variant="primary"
                  fontSize="heading-m"
                  onFollow={() => setCustomizeTabsVisible(true)}
                >
                  Customize Tabs
                </Link>
              </Box>
            )}
            <br />
            {tabOrderLoaded === true ? (<Tabs
              tabs={tabs?.map((tab) => (
                {
                  label: tab?.label,
                  id: tab?.id,
                  disabled: (tab?.id !== 'HOME' && tab?.id !== 'AppsLibrary' && !(tabOrderLoaded)),
                  content: (
                    tab?.tabType === 'BOARD' ? (
                      <CPBoardView
                        pageType={tab?.id}
                        tabType={tab?.tabType}
                        owner={selectedCPView}
                        openResource={updateTab}
                        viewAccess={viewAccess}
                        addOrEditAccess={addOrEditAccess}
                      />
                    ) : tab?.tabType === 'APPS' ? (
                      <Apps closePortalowner={selectedCPView} addOrEditAccess={addOrEditAccess} />
                    ) : tab?.tabType === 'LIST' ? (
                      <CustomMultipleResourcePage
                        pageType={tab?.id}
                        tabType={tab?.tabType}
                        owner={selectedCPView}
                        activeHref={activeHref}
                        viewAccess={viewAccess}
                        addOrEditAccess={addOrEditAccess}
                        resetHref={resetHref}
                      />
                    ) : (
                      <></>
                    )
                  ),
                  action: (
                    (isPortalAdmin && tab?.id !== 'HOME' && tab?.id !== 'AppsLibrary' ||
                      (addOrEditAccess && tab?.id !== 'HOME' && tab?.id !== 'AppsLibrary' && tab?.id !== 'AI/ML')) &&
                    <ButtonDropdown
                      items={[{ id: "hide-tab", text: "hide tab for team" }]}
                      ariaLabel="tab actions"
                      variant="icon"
                      onItemClick={(event) => {
                        if (event?.detail?.id === 'hide-tab') {
                          hideOrUnhideCustomTab(tab?.id, true);
                        }
                      }}
                      expandToViewport={true}
                    />
                  )
                }
              ))}
              activeTabId={activeTabId}
              onChange={(event) => {
                setActiveHref()
                if (event.detail.activeTabId === 'AppsLibrary') {
                  history.push(`/AppsLibrary`)
                } else {
                  history.push(`/ClosePortal/${event.detail.activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}`)
                }
                setActiveTabId(event.detail.activeTabId)
              }}
            />) : <><StatusIndicator colorOverride="blue" type="loading">
                      Fetching Tab Configuration For The Selected Close Portal Team
                    </StatusIndicator></>}
            
            {/* )} */}

            <CreateTeamModal
              visible={visible}
              onDismiss={resetModalParams}
              onCreateTeam={createNewOwner}
              onUpdateTeam={updateTeam}
              isPortalAdmin={isPortalAdmin}
              isSupportAdmin={isSupportAdmin}
              modalLoading={modalLoading}
              errorText={errorText}
              newTeamName={newTeamName}
              setNewTeamName={setNewTeamName}
              newTeamLDAP={newTeamLDAP}
              setNewTeamLDAP={setNewTeamLDAP}
              selectedOrgs={selectedOrgs}
              setSelectedOrgs={setSelectedOrgs}
              selectedRegions={selectedRegions}
              setSelectedRegions={setSelectedRegions}
              selectedVP={selectedVP}
              setSelectedVP={setSelectedVP}
              organizations={organizations}
              regions={regions}
              directReports={directReports}
              getDirectReportsCaller={getDirectReportsCaller}
              availableTeams={cpOwnerOptions?.filter(team => team.owner_type === 'TEAM')}
              selectedTeamToEdit={selectedTeamToEdit}
              setSelectedTeamToEdit={setSelectedTeamToEdit}
              isAteamBI={isAteamBI}
              onLoadTeamDetails={loadTeamDetails}
              onClearError={() => setErrorText('')}
            />

            <CustomizeTabsModal
              visible={customizeTabsVisible}
              onDismiss={() => {
                setCustomizeTabsVisible(false)
                setModalLoading(false)
                setErrorText()
                setSelectedTabControlsSegmentId("add")
                setNewTabName('')
                setSelectedUpdateOrDeleteTab()
                setUpdateTabNameInput('')
                setSelectedTabToUnhide()
              }}
              modalLoading={modalLoading}
              errorText={errorText}
              allTabs={allTabs}
              allCustomTabs={allCustomTabs}
              hiddenTabs={hiddenTabs}
              selectedTabControlsSegmentId={selectedTabControlsSegmentId}
              setSelectedTabControlsSegmentId={setSelectedTabControlsSegmentId}
              newTabName={newTabName}
              setNewTabName={setNewTabName}
              selectedUpdateOrDeleteTab={selectedUpdateOrDeleteTab}
              setSelectedUpdateOrDeleteTab={setSelectedUpdateOrDeleteTab}
              updateTabNameInput={updateTabNameInput}
              setUpdateTabNameInput={setUpdateTabNameInput}
              selectedTabToUnhide={selectedTabToUnhide}
              setSelectedTabToUnhide={setSelectedTabToUnhide}
              onAddTab={addNewCustomTab}
              onUpdateTab={updateExistingCustomTab}
              onDeleteTab={deleteExistingCustomTab}
              selectedTabType={selectedTabType}
              setSelectedTabType={setSelectedTabType}
              onUnhideTab={() => {
                if (selectedTabToUnhide) {
                  hideOrUnhideCustomTab(selectedTabToUnhide?.value, false)
                } else {
                  setErrorText('Please select a tab to unhide!')
                }
              }}
              visibleTabs={tabs}
              onReorderTabs={handleReorderTabs}
              orderedTabs={orderedTabs}
              selectedCPView={selectedCPView}
            />

          </Container>
        </ContentLayout>


      </Box>
  );
  return (
    <AppLayout
      disableContentPaddings={false}
      // navigation={<SideNav activeHref={ln.pathname} orgs={organizations} />}
      maxContentWidth={Number.MAX_VALUE}
      navigationHide={true}
      content={Content}
      contentType="default"
      headerSelector="#TopBar"
      toolsHide={true}
    // onNavigationChange={() => {
    //   setNavOpen(!NavOpen);
    // }}
    />
  );
};

export default AllProducts;
